import client from "../index";
import { GET_AGENT, GET_AGENTS } from "./query";
import { createReferenceMemo } from "../referenceMemo";
import {
  CREATE_AGENT,
  UPDATE_AGENT,
  DELETE_AGENT,
  SYNC_AGENT_FILES,
  SYNC_AGENT_ASSISTANT,
  CHAT_WITH_SPARK_AGENT,
  CHAT_WITH_AGENT_CONTACT,
} from "./mutation";

// Agents are reference data; memoize per-input and invalidate on the agent
// mutations below.
const agentsMemo = createReferenceMemo();

export const apiGetAgent = (input) =>
  agentsMemo.run(`agent:${JSON.stringify(input || {})}`, () =>
    client
      .query({
        query: GET_AGENT,
        variables: {
          input,
        },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        return res.data.agent;
      })
  );

export const apiGetAllAgents = (filter = {}) =>
  agentsMemo.run(`agents:${JSON.stringify(filter || {})}`, () =>
    client
      .query({
        query: GET_AGENTS,
        variables: {
          input: filter,
        },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        return res.data.agents;
      })
  );

export const apiCreateAgent = (data) => {
  // Strip out fields that are not part of CreateAgentInput
  const { id, createdAt, updatedAt, __typename, openaiAssistantId, openaiVectorStoreId, openaiFiles, ...cleanData } = data;
  return client
    .mutate({
      mutation: CREATE_AGENT,
      variables: { input: cleanData },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      agentsMemo.clear();
      return res.data.createAgent.agent;
    });
};

export const apiUpdateAgent = (data) => {
  // Strip out fields that are not part of UpdateAgentInput
  const { createdAt, updatedAt, __typename, openaiAssistantId, openaiVectorStoreId, openaiFiles, ...cleanData } = data;
  return client
    .mutate({
      mutation: UPDATE_AGENT,
      variables: { input: cleanData },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      agentsMemo.clear();
      return res.data.updateAgent.agent;
    });
};

export const apiDeleteAgent = (id) => {
  return client
    .mutate({
      mutation: DELETE_AGENT,
      variables: {
        id,
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      agentsMemo.clear();
      return res.data.deleteAgent.id;
    });
};

export const apiSyncAgentFiles = (agentId, fileUrls) => {
  return client
    .mutate({
      mutation: SYNC_AGENT_FILES,
      variables: {
        input: {
          agentId,
          fileUrls,
        },
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      agentsMemo.clear();
      return res.data.syncAgentFiles.agent;
    });
};

export const apiSyncAgentAssistant = (agentId) => {
  return client
    .mutate({
      mutation: SYNC_AGENT_ASSISTANT,
      variables: {
        input: {
          agentId,
        },
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      agentsMemo.clear();
      return res.data.syncAgentAssistant;
    });
};

export const apiChatWithAgent = (agentId, message, threadId, fileUrls) => {
  return client
    .mutate({
      mutation: CHAT_WITH_SPARK_AGENT,
      variables: {
        input: {
          agentId,
          message,
          threadId,
          fileUrls,
        },
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res.data.chatWithAgent;
    });
};

export const apiChatWithAgentContact = ({ agentId, contactId, authorId, domain, locationId, message, parentId, includeHistory }) => {
  return client
    .mutate({
      mutation: CHAT_WITH_AGENT_CONTACT,
      variables: {
        input: {
          agentId,
          contactId,
          authorId,
          domain,
          locationId,
          message,
          parentId,
          includeHistory,
        },
      },
      fetchPolicy: "no-cache",
    })
    .then((res) => {
      return res.data.chatWithAgentContact;
    });
};

// Alias for consistency
export const apiGetAgents = apiGetAllAgents;
